import { IMapBounds } from '../components/SpacesMap';

/**
 * Mirrors the backend's own BoundingBox helper (MachineryController.
 * BoundingBox) -- a cheap lat/lng rectangle around a point. Used to turn a
 * resolved "search near this point" (LocationOnlySearchBar, for the
 * Operators/Accessories map tabs) into the same MinLat/MaxLat/MinLng/MaxLng
 * viewport shape the map's own pan/zoom already filters by, since
 * OperatorSearchRequest/AccessorySearchRequest have no separate circle-
 * radius parameter the way HeavyDutyMachinerySearchRequest's own Lat/Lng/
 * RadiusKm does -- setting these bounds directly reuses the exact same
 * filtering path a manual pan/zoom already exercises, no new backend
 * capability needed.
 */
const KM_PER_DEGREE_LAT = 111;

export const boundingBoxFromPoint = (lat: number, lng: number, radiusKm: number): IMapBounds => {
  const latDelta = radiusKm / KM_PER_DEGREE_LAT;
  const kmPerDegreeLng = KM_PER_DEGREE_LAT * Math.cos((lat * Math.PI) / 180);
  const lngDelta = kmPerDegreeLng > 0.0001 ? radiusKm / kmPerDegreeLng : 180;
  return { minLat: lat - latDelta, maxLat: lat + latDelta, minLng: lng - lngDelta, maxLng: lng + lngDelta };
};
